import { createContext, useState } from "react"

import { UserType } from "types/common"

//eslint-disable-next-line
export const UserContext = createContext<any>({})

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [page, setPage] = useState(1)
    const [postPerPage, setPostPerPage] = useState(5)
    const [inputValue, setInputValue] = useState("")

    const handleFirstPage = () => {
        setPage(1)
    }

    const handlePostPerPageChange = (value: number) => {
        setPage(1)
        setPostPerPage(value)
    }

    const handleInputValueChange = (value: string) => {
        setPage(1)
        setInputValue(value)
    }

    const handleNextPage = (list: UserType[]) => {
        if (list.length >= postPerPage) {
            setPage((current) => current + 1)
        }
    }

    const handlePrevPage = () => {
        if (page !== 1) setPage((current) => current - 1)
    }

    return (
        <UserContext.Provider
            value={{
                page,
                setPage,
                postPerPage,
                setPostPerPage,
                inputValue,
                handleInputValueChange,
                handleFirstPage,
                handlePostPerPageChange,
                handleNextPage,
                handlePrevPage,
            }}
        >
            {children}
        </UserContext.Provider>
    )
}

export default UserContext
